// extracted by css-extract-rspack-plugin
export default {"flexCenter":"Topics-module__flexCenter__Ebav1","repoIcon":"Topics-module__repoIcon__n_QUq"};